<template>
  <b-sidebar
      id="filter-sidebar"
      :visible="visible"
      size="lg"
      :title="'Filtrele'"
      shadow
      backdrop
      no-header
      no-footer
      cancel-title="Kapat"
      ok-title="Filtrele"
      right
      @hidden="$emit('hidden')"
    >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          FİLTRELE
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- Filtre içerikleri -->
      <b-card>
        <div class="dropdown-style d-flex" v-if="type == 0 && !isFenomen">
          <v-select
            id="inf_id"
            :options="safeOptions"
            :value="infId"
            @input="updateInfId"
            :reduce="reduceFunction"
            class="w-100 fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
            placeholder="Tüm Fenomenler"
            multiple
          />
        </div>

        <b-form-group label="Bağlantı Türü" class="mt-2">
          <v-select
            id="is_internal_domain"
            :value="filterOptions.is_internal_domain"
            @input="updateFilter('is_internal_domain', $event)"
            :options="[
              { value: null, label: 'Tümü' },
              { value: 0, label: 'Dış Bağlantı' },
              { value: 1, label: 'İç Bağlantı' }
            ]"
            :reduce="option => option.value"
            label="label"
            :clearable="false"
            name="is_internal_domain"
          />
        </b-form-group>

        <b-form-group label="Durumu" class="mt-2">
          <v-select
            id="status"
            :value="filterOptions.status"
            @input="updateFilter('status', $event)"
            :options="[
              { value: null, label: 'Tümü' },
              { value: 1, label: 'Aktif' },
              { value: 0, label: 'Pasif' },
              { value: 2, label: 'Bekleniyor' }
            ]"
            :reduce="option => option.value"
            label="label"
            :clearable="false"
            name="is_internal_domain"
          />
        </b-form-group>
         
        <!-- <b-form-checkbox
          class="mt-2"
          name="check-button"
          switch
          inline
          :checked="filterOptions.smsShow"
          @change="updateFilter('smsShow', $event)"
        >
          Sms Göster
        </b-form-checkbox>
        <b-form-checkbox
          class="mt-2"
          name="check-button"
          switch
          inline
          :checked="filterOptions.storyShow"
          @change="updateFilter('storyShow', $event)"
        >
          Story Göster
        </b-form-checkbox>
        <b-form-checkbox
          class="mt-2"
          name="check-button"
          switch
          inline
          :checked="filterOptions.bioShow"
          @change="updateFilter('bioShow', $event)"
        >
          Bio Göster
        </b-form-checkbox>
        <b-form-checkbox
          class="mt-2"
          name="check-button"
          switch
          inline
          :checked="filterOptions.fenomenShow"
          @change="updateFilter('fenomenShow', $event)"
        >
          Fenomen Paylaşımları
        </b-form-checkbox> -->
      </b-card>
      <div class="d-flex justify-content-center align-items-center p-2">
        <b-button variant="outline-danger" @click="clearFilters">
          <feather-icon icon="Trash2Icon" />
          Temizle
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import bio from '@/router/company';
import { 
  BButton,
  BFormGroup, 
  BCard,
  BFormCheckbox,
  BModal,
  BSidebar,
  BForm} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterSidebar',
  components: {
    BSidebar,
    BFormGroup,
    BButton,
    BCard,
    BFormCheckbox,
    vSelect,
    BModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: null
    },
    fenomenList: {
      type: Array,
      default: () => []
    },
    infId: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Object,
      default: () => ({
        is_internal_domain: null,
        smsShow: false,
        storyShow: false,
        fenomenShow: false,
        bioShow: false
      })
    }
  },
  computed: {
    safeOptions() {
      return Array.isArray(this.fenomenList) ? this.fenomenList : [];
    },
  },
  methods: {
    reduceFunction(val) {
      return val && typeof val === 'object' && 'value' in val ? val.value : null;
    },
    updateInfId(value) {
      this.$emit('update:infId', value);
    },
    updateFilter(key, value) {
      const newFilter = { ...this.filterOptions };
      newFilter[key] = value;
      this.$emit('update:filterOptions', newFilter);
    },
    clearFilters() {
      this.$emit('update:infId', []);
      this.$emit('update:filterOptions', {
        is_internal_domain: null,
        status: null,
      });
      this.$emit('filters-cleared');
    }
  }
}
</script>
<style  lang="scss" scoped>
.vs__selected{
  color:#FFF;
}
</style>